/* eslint-disable max-len */
import { setIsModalOpen } from './actions';

const NOT_AVAILABLE_AND_AUTOMATIC_PAYMENT_DRAFTING_MESSAGE = '<b>Enrolled in Autopay.</b> The scheduled payment will be made on time. Contact us at {{customerServicePhoneNumber}} if you need assistance.';

export const AUTOPAY_PAYMENT_STATUSES = {
  desktop: {
    Change_Request_Processing: {
      iconName: 'pending',
      message: 'Your Autopay update request is processing and cannot be changed.',
    },
    Change_Requested: {
      iconName: 'pending',
      linkLabel: 'Cancel Autopay Update Request',
      message: 'We are processing your request to update Autopay.',
      operation: 'modal',
    },
    Enable_Requested: {
      header: 'Autopay Enrollment Pending',
      iconName: 'pendingGray',
      linkLabel: 'Cancel Autopay Request',
      message: 'We are processing your request to enroll in autopay.',
      operation: 'modal',
    },
    Enabled: {
      header: 'Enrolled in Automatic Payments',
      iconName: 'approved',
      linkLabel: 'Edit Settings',
      message: 'Your automatic payment is scheduled for {{nextDraftDate}}.',
      operation: 'navigate',
    },
    Not_Available: {
      iconName: 'paymentWarningS',
      message: 'At this time you cannot set up autopay. Please contact us at {{customerServicePhoneNumber}} for assistance.',
    },
    Not_Available_And_Automatic_Payment_Drafting: {
      iconName: 'pending',
      message: NOT_AVAILABLE_AND_AUTOMATIC_PAYMENT_DRAFTING_MESSAGE,
    },
    Not_Enabled: null,
    Stop_Request_Processing: {
      iconName: 'pending',
      message: 'Your Autopay unenroll request is processing and cannot be changed. All autopayments will be stopped as of {{cancellableDate}}.',
    },
    Stop_Requested: {
      iconName: 'pending',
      linkLabel: 'Cancel Request to Unenroll from Autopay',
      message: 'We are processing your request to unenroll from Autopay.',
      operation: 'modal',
    },
  },
  mobile: {
    Change_Request_Processing: {
      button: null,
      iconType: 'outlinedPendingPurple',
      message: 'Your Autopay update request is processing and cannot be changed.',
    },
    Change_Requested: {
      button: {
        label: 'Cancel Autopay Update Request',
        operation: setIsModalOpen,
        operationResponse: { key: 'cancel', value: true },
      },
      iconType: 'outlinedPendingPurple',
      message: 'We are processing your request to update Autopay.',
    },
    Enable_Requested: {
      button: {
        label: 'Cancel Autopay Request',
        operation: setIsModalOpen,
        operationResponse: { key: 'cancel', value: true },
      },
      header: 'Autopay Enrollment Pending',
      iconType: 'pendingGray',
      message: 'We are processing your request to enroll in autopay.',
    },
    Enabled: {
      button: {
        label: 'Edit Settings',
        operationResponse: 'AutopayPreConfirmation',
      },
      header: 'Enrolled in Automatic Payments',
      iconType: 'approved',
      message: 'Your automatic payment is scheduled for {{nextDraftDate}}.',
    },
    Not_Available: {
      button: null,
      iconType: 'outlinedWarning',
      message: 'At this time you cannot set up autopay. Please contact us at {{customerServicePhoneNumber}} for assistance.',
    },
    Not_Available_And_Automatic_Payment_Drafting: {
      button: null,
      iconType: 'outlinedPendingPurple',
      message: NOT_AVAILABLE_AND_AUTOMATIC_PAYMENT_DRAFTING_MESSAGE,
    },
    Not_Enabled: null,
    Stop_Request_Processing: {
      button: null,
      iconType: 'outlinedPendingPurple',
      message: 'Your Autopay unenroll request is processing and cannot be changed. All autopayments will be stopped as of {{cancellableDate}}.',
    },
    Stop_Requested: {
      button: {
        label: 'Cancel Request to Unenroll from Autopay',
        operation: setIsModalOpen,
        operationResponse: { key: 'cancel', value: true },
      },
      iconType: 'outlinedPendingPurple',
      message: 'We are processing your request to unenroll from Autopay.',
    },
  },
};
